angular.module('signalview.metricsSidebar', ['signalview.metricsPicker']);
